import { replaceFontSizesWithJunctionValues } from './replaceFontSizesWithJuctionValues.ts';

export const revertEscapedComments = (text) => {
  return text ? text.replace('&lt;!--', '<!--').replace('--&gt;', '-->') : text;
};

export const cleanUpHTML = (data) => {
  try {
    const htmlDoc = new DOMParser().parseFromString(data, 'text/html');

    const trs = htmlDoc.querySelectorAll('tr');
    trs.forEach((tr) => {
      if (tr.style.display !== 'none') {
        let hasChildren = false;
        tr.childNodes.forEach((td) => {
          if (td.hasChildNodes()) {
            hasChildren = true;
          }
        });
        if (!hasChildren) {
          let height = tr.getAttribute('height');
          if (height <= 8) {
            height = 8;
          } else {
            height = 28;
          }
          tr.setAttribute('height', height);
          tr.style.height = `${height}px`;
          tr.childNodes.forEach((td) => {
            if (!td.style) {
              td.style = `height: ${height}px`; // display: block;
            } else {
              td.style.height = `${height}px`;
            }
          });
        }
      }
    });

    const hasScript = htmlDoc.querySelector('script');
    if (hasScript && hasScript.innerText) {
      // eslint-disable-next-line no-unused-vars
      const script = hasScript.innerText.replaceAll('document', 'htmlDoc');

      // eslint-disable-next-line no-eval
      eval(script);
    }

    const toBeRemoved = htmlDoc.querySelectorAll("[style*='display:none']");
    toBeRemoved.forEach((val) => {
      val.parentNode.removeChild(val);
    });

    return revertEscapedComments(
      replaceFontSizesWithJunctionValues(htmlDoc.documentElement.innerHTML)
    );
  } catch (e) {
    return '';
  }
};

export default cleanUpHTML;
